import { SidebarTagProps } from "components/templates/TagsSidebar";
import { AssetTagCreateType } from "graphqlBase/types";
import { atom } from "recoil";

export const assetTagsToCreateAtom = atom<AssetTagCreateType[]>({
  key: "assetTagsToCreateAtom",
  default: [],
});

export const assetTagsforTagsListAtom = atom<SidebarTagProps[] | undefined>({
  key: "assetTagsforTagsListAtom",
  default: undefined,
});

export const assetTagIdsToDeleteAtom = atom<string[]>({
  key: "assetTagIdsToDeleteAtom",
  default: [],
});
